import { render, staticRenderFns } from "./accessDetail.vue?vue&type=template&id=47623488&scoped=true&"
import script from "./accessDetail.vue?vue&type=script&lang=js&"
export * from "./accessDetail.vue?vue&type=script&lang=js&"
import style0 from "./accessDetail.vue?vue&type=style&index=0&id=47623488&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47623488",
  null
  
)

component.options.__file = "accessDetail.vue"
export default component.exports